var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAideIcone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.39307 6.00018C6.5498 5.55462 6.85917 5.17891 7.26637 4.9396C7.67357 4.70028 8.15233 4.6128 8.61785 4.69265C9.08337 4.7725 9.50561 5.01453 9.80978 5.37586C10.114 5.7372 10.2804 6.19452 10.2797 6.66684C10.2797 8.00018 8.27973 8.66684 8.27973 8.66684M8.33317 11.3335H8.33984M14.9998 8.00016C14.9998 11.6821 12.0151 14.6668 8.33317 14.6668C4.65127 14.6668 1.6665 11.6821 1.6665 8.00016C1.6665 4.31826 4.65127 1.3335 8.33317 1.3335C12.0151 1.3335 14.9998 4.31826 14.9998 8.00016Z",
    stroke: "#09090B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAideIcone);
export default __webpack_public_path__ + "static/media/aide_icone.cc88663ebd885013527043792f410860.svg";
export { ForwardRef as ReactComponent };